import { useEffect, useState } from "react";

// « Pas de survol possible » : appareil tactile, ou fenêtre étroite (mobile/tablette).
// Sur ces appareils le navigateur refuse toute lecture automatique avec du son : les
// vidéos démarrent donc seules en muet, avec un bouton pour activer le son.
// Le test de largeur sert de garde-fou : certains appareils déclarent mal `hover`.
function noHover() {
  return (
    !window.matchMedia("(hover: hover) and (pointer: fine)").matches ||
    window.innerWidth < 900
  );
}

export function useIsTouchDevice() {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    const update = () => setTouch(noHover());
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return touch;
}
